import React, { PureComponent } from 'react';
import {
    Text,
    TouchableOpacity,
    View,
    Image,
    FlatList, ScrollView,
} from 'react-native-web';
import PropTypes from 'prop-types';
import * as Animatable from 'react-native-animatable';

// Custom Components
import { Button, InScreenModal, NavBar } from '../components';
import LoadingView from './component_loading_view';

// Configs
import GLOBAL from '../configs/config_global';

export default class SquareLocationSelector extends PureComponent {
    // region Props
    static propTypes = {
        showNote: PropTypes.bool,
        buttonText: PropTypes.string,
        noteText: PropTypes.string,
        onLocationSelected: PropTypes.func,
        onRefreshPressed: PropTypes.func,
        isListRefreshing: PropTypes.bool,
        locationList: PropTypes.array,
        currentLocationIndex: PropTypes.number,
        customText: PropTypes.string,
        customOnPress: PropTypes.func
    };

    static defaultProps = {
        showNote: true,
        buttonText: 'Switch Location',
        noteText: 'Your selected location will affect your\nmobile ordering notifications.',
        onLocationSelected: () => {},
        onRefreshPressed: () => {},
        isListRefreshing: false,
        locationList: [],
        currentLocationIndex: 0,
        customText: null,
        customOnPress: () => {}
    };
    // endregion

    // region Constructor
    state = {
        showModal: false,
        selectedIndex: 0
    };
    // endregion

    // region Function - Hide Modal
    hideModal = () => this.setState({ showModal: false });
    showModal = () => this.setState({ showModal: true, selectedIndex: this.props.currentLocationIndex });
    // endregion

    // region Render Square Location Item
    renderSquareLocationItem(item, index) {
        let logoContainerSize = 32,
            logoSize = 20,
            indicatorSize = 24,
            isSelected = this.state.selectedIndex === index;

        return(
            <TouchableOpacity
                key={`squareLocationItem_${item['squareup_location_id']}`}
                onPress={() => this.setState({ selectedIndex: index })}
                style={{
                    alignSelf: 'stretch', height: 70, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 16,
                    borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER
                }}>
                {/* Square Logo */}
                <View style={{
                    width: logoContainerSize, height: logoContainerSize,
                    borderRadius: logoContainerSize / 2, backgroundColor: 'rgb(237, 239, 242)',
                    alignItems: 'center', justifyContent: 'center'
                }}>
                    <Image
                        source={require('../images/image_square_big.png')}
                        style={{ width: logoSize, height: logoSize }}
                    />
                </View>

                {/* Name */}
                <Text style={{ fontWeight: '500', fontSize: 18, flex: 1, marginLeft: 16 }}>
                    {item['name']}
                </Text>

                {/* Selection Indicator */}
                <View style={{
                    width: indicatorSize, height: indicatorSize,
                    borderRadius: indicatorSize / 2,
                    borderWidth: 2, borderColor: isSelected ? GLOBAL.COLOR.MAIN : GLOBAL.COLOR.TEXT_LIGHT_GRAY,
                    backgroundColor: isSelected ? GLOBAL.COLOR.MAIN : 'white', marginLeft: 16,
                    alignItems: 'center', justifyContent: 'center'
                }}>
                    {isSelected && <View style={{ width: 8, height: 8, backgroundColor: 'white', borderRadius: 4 }}/>}
                </View>
            </TouchableOpacity>
        );
    }
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const {
            onLocationSelected,
            onRefreshPressed,
            isListRefreshing,
            locationList,
            currentLocationIndex,
            showNote,
            noteText,
            buttonText,
            customOnPress,
            customText
        } = this.props;

        return(
            <InScreenModal visible={this.state.showModal}>
                {/* Nav Bar */}
                <NavBar
                    title={'Square Locations'}
                    horizontalSpacing={16}
                    hideBorder={true}
                    leftButtonOnPress={() => this.hideModal()}
                    leftButtonIconName={'close'}
                />

                {/* Content */}
                <View style={{ flex: 1, width: '100%', paddingBottom: 24 }}>
                    {/* Description */}
                    <Text style={{ marginTop: 8, color: GLOBAL.COLOR.BASIC.NEUTRAL_DARK_GREY, textAlign: 'center', fontSize: 18, lineHeight: 28 }}>
                        Your linked Square account has multiple locations,{'\n'}select one that you want to use.
                    </Text>

                    {
                        showNote &&
                        <Text style={{ fontWeight: '400', color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, fontSize: 16, marginTop: 16, textAlign: 'center', marginHorizontal: 24, letterSpacing: 0.2 }}>
                            <Text style={{ fontWeight: 'bold', color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, fontSize: 16 }}>
                                Note:{' '}
                            </Text>
                            <Text style={{ fontSize: 16, color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY }}>
                                {noteText}
                            </Text>
                        </Text>
                    }

                    {/* Location List */}
                    <View style={{ flex: 1, width: '100%', marginTop: 8 }}>
                        {/* Item List */}
                        <Animatable.View animation={'fadeIn'} style={{ flex: 1, width: '100%' }}>
                            <ScrollView
                                style={{ flex: 1, width: '100%' }}
                                contentContainerStyle={{ paddingVertical: 24 }}
                                showsVerticalScrollIndicator={false}>
                                {/* Top Divider */}
                                <View style={{ height: 1, width: '100%', backgroundColor: GLOBAL.COLOR.DIVIDER }}/>

                                {/* List of locations */}
                                {locationList.map((item, index) => this.renderSquareLocationItem(item, index))}
                            </ScrollView>

                            {/* Refresh Button */}
                            {/* <TouchableOpacity */}
                            {/*     onPress={onRefreshPressed} */}
                            {/*     style={{ marginTop: 24, alignItems: 'center' }}> */}
                            {/*     <Text style={{ color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, textAlign: 'center', fontSize: 16 }}> */}
                            {/*         Can't find the location you're looking for? */}
                            {/*     </Text> */}

                            {/*     <Text style={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontSize: 16, textAlign: 'center', marginTop: 4, fontWeight: 'bold' }}> */}
                            {/*         Refresh the list */}
                            {/*     </Text> */}
                            {/* </TouchableOpacity> */}
                        </Animatable.View>

                        {/* Gradient */}
                        <Image
                            source={require('../images/image_gradient_down.png')}
                            style={{ position: 'absolute', top: 0, left: -1, right: -1, height: 20 }}
                        />

                        {/* Gradient */}
                        <Image
                            source={require('../images/image_gradient.png')}
                            style={{ position: 'absolute', bottom: 0, left: -1, right: -1, height: 20 }}
                        />
                    </View>

                    {/* Confirm Button */}
                    <Button
                        onPress={() => {
                            if (currentLocationIndex !== this.state.selectedIndex) onLocationSelected(this.state.selectedIndex);
                            this.hideModal();
                        }}
                        text={buttonText}
                        textStyle={{ color: 'white' }}
                        style={{ marginHorizontal: 24 }}
                    />

                    {/* Custom Button */}
                    {
                        customText ?
                            <Button
                                onPress={() => {
                                    customOnPress();
                                    this.hideModal();
                                }}
                                text={customText}
                                textStyle={{ color: 'white' }}
                                backgroundColor={GLOBAL.COLOR.BASIC.UI_BLUE}
                                style={{ marginHorizontal: 24, marginTop: 8 }}
                            />
                            :
                            null
                    }

                    {/* Loading Cover View */}
                    {isListRefreshing && <LoadingView isAbsolute={true}/>}
                </View>
            </InScreenModal>
        );
    }
    // endregion
}
